module.exports = function(){ /* empty */ };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/~/core-js/library/modules/_add-to-unscopables.js
// module id = 857
// module chunks = 0